// import { useGlobal } from '@/hooks/useGlobal';
import { getTitlePage } from '@/util/titlePage';
import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { appRoutes } from './routes';

interface IProps {
    isAuthenticated: boolean;
}

export const OpenSiteRoutes: React.FC<IProps> = ({ isAuthenticated }) => {
    const location = useLocation();

    return isAuthenticated ? (
        <Navigate to={`/${appRoutes.MAIN.ROOT}`} state={{ from: location }} replace />
    ) : (
        <Outlet />
    );
};
